import { get } from 'lodash'
import groupBy from 'lodash/groupBy'

import { employeeUser } from 'modules/core/store/collections/users'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import employeesCollection from 'modules/employees/store/collections/employees'
import { employeeJob } from 'modules/job_catalog/store/collections/roles'
import EmployeeWithShifts from 'modules/shift_management/store/internal/models/EmployeeWithShifts'
import { LeavePayload } from 'modules/shift_management/store/internal/models/Leave'
import { PlanningVersionPayload } from 'modules/shift_management/store/internal/models/PlanningVersion'
import { RestDayPayload } from 'modules/shift_management/store/internal/models/RestDay'
import { ShiftPayload } from 'modules/shift_management/store/internal/models/Shift'
import ShiftPermissions from 'modules/shift_management/store/internal/models/ShiftPermissions'
import ShiftsRow from 'modules/shift_management/store/internal/models/ShiftsRow'
import type CompanyHoliday from 'modules/timeoff/store/models/CompanyHoliday'

import { EmployeePermissions } from './types'

const buildEmployeeParamsFromResources = (
  employees: EmployeePermissions[],
  leaves: Array<LeavePayload> | undefined,
  planningVersions: Array<PlanningVersionPayload> | undefined,
  shifts: Array<ShiftPayload> | undefined,
  companyHolidays: CompanyHoliday[],
  restDays: Array<RestDayPayload> | undefined,
  contractVersions: ContractVersions
): ShiftsRow[] => {
  if (!employees) {
    return []
  }

  const groupedLeaves = groupBy(leaves, (leave) => leave.employee_id)
  const groupedPlanningVersions = groupBy(planningVersions, (pv) => pv.employee_id)
  const groupedShifts = groupBy(shifts, (shift) => shift.employee_id)
  const groupedHolidays = groupBy(companyHolidays, (holiday) => holiday.attributes.location_id)
  const groupedRestDays = groupBy(restDays, (restDay) => restDay.employee_id)

  return employees.map((employee) => {
    const id = employee.id
    const collectionEmployee = employeesCollection.find({ id })
    const employeeAvatar =
      (collectionEmployee && employeeUser(collectionEmployee).attributes.avatar) || ''
    const fullName = (collectionEmployee && employeeUser(collectionEmployee).fullName()) || ''
    const job = collectionEmployee ? employeeJob(contractVersions, collectionEmployee) : ''
    const locationId = collectionEmployee ? collectionEmployee.attributes.location_id : null
    const holidays = locationId ? get(groupedHolidays, locationId, []) : []

    return new ShiftsRow({
      id,
      title: fullName,
      job,
      avatar: employeeAvatar,
      permissions: ShiftPermissions.buildFromRequest(employee.permissions),
      employees: [
        EmployeeWithShifts.buildFromRequest({
          ...employee,
          employeeAvatar,
          fullName,
          job,
          leaves: groupedLeaves[id] ?? [],
          planning_versions: groupedPlanningVersions[id] ?? [],
          shifts: groupedShifts[id] ?? [],
          holidays,
          restDays: groupedRestDays[id] ?? [],
          permissions: ShiftPermissions.buildFromRequest(employee.permissions),
        }),
      ],
    })
  })
}

export default buildEmployeeParamsFromResources
